<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetBankPageRatesChartNbkr } from '~/components/widget/bank-page'
import { WidgetSidebarRates } from '~/components/widget/sidebar-rates'
import { WidgetRatesNbkr } from '~/components/widget/rates'
import { WidgetSeoContent } from '~/components/widget/seo'
import { WidgetFaqList } from '~/components/widget/faq-list'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetCustomerCareNbkr } from '~/components/widget/customer-care-nbkr'
import { WidgetImportantNews } from '~/components/widget/important-news'

const { t } = useI18n()
const { pathWithoutLocale } = useLocalizedPath()

const breadcrumbs = computed(() => [
  { title: t('common.exchange_rates'), url: '/rates' },
  { title: t('page.rates.nbkr.breadcrumbs_title'), url: '/rates/nbkr' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
            <WidgetCustomerCareNbkr />
            <SidebarBlock variant="white" :heading-text="$t('common.exchange_rates')">
              <WidgetSidebarRates />
            </SidebarBlock>
          </aside>
        </template>
        <div class="space-y-5" role="main">
          <WidgetSeoContent position="upper" />
          <WidgetSeoContent position="content" />
          <ContentBlock
            :heading-text="$t('page.rates.nbkr.content_heading')"
            variant="white"
            heading-class="h4"
            heading-tag="h2"
          >
            <WidgetRatesNbkr />
          </ContentBlock>

          <ContentBlock variant="white">
            <WidgetBankPageRatesChartNbkr :title="$t('common.nbkr')" />
          </ContentBlock>

          <WidgetSeoContent position="bottom" />

          <WidgetImportantNews
            :query-params="{
              per_page: '7',
              'filter[tag]': 'НБ КР',
              'filter[position]': 'important',
              'filter[type]': 'news'
            }"
          />

          <WidgetFaqList
            :query-params="{
              'filter[faqable_url]': pathWithoutLocale
            }"
          />
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
